import VenueDetails from './VenueDetails';

export default VenueDetails;
